import moment from 'moment';
import { CustomerInfo } from '../../build-info';

moment.locale(CustomerInfo.defaultLanguage);

export default moment;
